import styled from 'styled-components'
import { SIZES } from '../../../styles/theme'

export const PosterPresentionStyle = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 150px);
  ${SIZES.mobile} {
    height: calc(100vh - 40px);
    overflow-y: scroll;
    padding-bottom: 200px;
  }

  #pdfContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
  }

  .pdfPageSelector {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
    background: #2d2c3c;

    button {
      color: white;
      background: transparent;
      font-size: 12px;
      border: solid 1px white;
      margin: 0 8px;
      border-radius: 8px;
      padding: 2px 8px;
      &:hover {
        background: white;
        color: #2d2c3c;
      }
    }
  }

  #bottomSection {
    color: white;
    background: #2d2c3c;
    padding: 30px 60px;
    font-size: 15px;
    ${SIZES.mobile} {
      padding: 20px;
      font-size: 11px;
    }

    .abstractTitle {
      font-weight: 400;
      letter-spacing: 1px;
      font-size: 1.5em;
    }

    .authorName {
      letter-spacing: 1px;
      margin-top: 15px;
      font-size: 1.2em;
    }

    .interactionSection {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 50px;
      ${SIZES.mobile} {
        margin-top: 30px;
        display: block;
      }
    }
  }
`
